<template>
  <div>
    <ul class="el-upload-list el-upload-list--picture-card">
      <li
        v-for="(item, index) in fileList"
        :key="index"
        tabindex="0"
        class="el-upload-list__item is-success"
        style="width:80px;height:80px">
        <img
          :src="item.url"
          class="el-upload-list__item-thumbnail">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview">
            <i
              class="el-icon-zoom-in"
              @click="handlePictureCardPreview(item)"></i>
          </span>
        </span>
      </li>
    </ul>
    <el-dialog
      :visible.sync="previewVisible"
      width="600px"
      append-to-body>
      <img
        width="100%"
        :src="previewUrl">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ImageList',
  components: {},
  props: {
    fileList: {
      type: Array,
      required: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      previewVisible: false,
      previewUrl: ''
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    handlePictureCardPreview(item) {
      this.previewUrl = item.url
      this.previewVisible = true
    }
  }
}
</script>
<style lang="stylus" scoped></style>
